<div class="d-flex justify-content-center flex-wrap">
    <ng-container *ngFor="let scorecardStatus of _visibleScorecardStatusFilter">
        <button
            class="m-1"
            cmpsEyeToggleButton
            [selected]="scorecardStatus.isSelected"
            [disabled]="!scorecardStatus.canBeDeselected"
            (click)="_onScorecardStatusSelectionChange(scorecardStatus)"
        >
            <span
                [class.sc-rank-and-scorecard-published-status-filter--published-icon]="
                    scorecardStatus.isPublished
                "
                [class.sc-rank-and-scorecard-published-status-filter--unpublished-icon]="
                    !scorecardStatus.isPublished
                "
            ></span>
            <span cmpsEyeToggleButtonLabel>{{
                scorecardStatus.name | translate
            }}</span>
        </button>
    </ng-container>

    <ng-container *ngFor="let rankFilter of ranksFilter">
        <button
            class="m-1"
            cmpsEyeToggleButton
            [selected]="rankFilter.isSelected"
            (click)="_onRankSelectionChange(rankFilter)"
        >
            <span
                class="sc-rank-and-scorecard-published-status-filter--line-icon"
                [style.background-color]="rankFilter.colour"
            ></span>
            <span cmpsEyeToggleButtonLabel
                >{{ rankFilter.rankName }}
                {{ _i18n._777_RANK | translate }}</span
            >
        </button>
    </ng-container>
</div>
